import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@bem-react/classname';

import Icon from '../icon';

import './style.scss';

const Input = React.forwardRef((props, ref) => {
  const {
    id,
    className,
    label,
    type,
    onChange,
    error,
    withIcon,
    iconSize,
    onBlur,
    onIconClick,
    ...attrs
  } = props;

  const inputCn = cn(className);

  return (
    <div className={`${inputCn('InputWrapper')} Input-Wrapper ${error && 'error'}`}>
      <div className={`${inputCn('LabelWrapper')} InputLabel-Wrapper`}>
        {label && (
          <label className={`${inputCn('InputLabel')} Input-Label`} htmlFor={id}>
            {label}
          </label>
        )}
      </div>
      <div className={`${inputCn('InputLabel')} Input-Inner`}>
        {withIcon && (
          <Icon
            className={`${inputCn('InputIcon')} Input-Icon`}
            icon={withIcon}
            iconSize={iconSize}
            onIconClick={onIconClick}
          />
        )}
        <input
          onBlur={onBlur}
          type={type}
          name={id}
          id={id}
          className={`${inputCn('Input')} Input`}
          ref={ref}
          onChange={onChange}
          autoComplete={type === 'password' ? 'new-password' : 'off'}
          {...attrs}
        />
      </div>
      {error ? (
        <span className={`${inputCn('InputError')} Input-Error`}>{error}</span>
      ) : (
        <div className={`${inputCn('InputError')} Input-Text`} />
      )}
    </div>
  );
});

Input.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  withIcon: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string
  ]),
  error: PropTypes.string,
  onInput: PropTypes.func,
};

Input.defaultProps = {
  className: '',
  label: '',
  withIcon: '',
  error: '',
  onInput: () => {},
};

export default Input;
